import type { Simulation } from '../../core/simulation/Simulation';
import type { Coordinate } from '../../core/types/SimulationTypes';
import { MathUtils } from '../../utils/MathUtils';

export type SandToolMode = 'raise' | 'lower';

export class SandTool {
  private mode: SandToolMode = 'raise';
  private brushSize: number = 3;
  private strength: number = 0.5;

  public setMode(mode: SandToolMode): void {
    this.mode = mode;
  }

  public getMode(): SandToolMode {
    return this.mode;
  }

  public setBrushSize(size: number): void {
    this.brushSize = MathUtils.clamp(size, 1, 20);
  }

  public getBrushSize(): number {
    return this.brushSize;
  }

  public setStrength(strength: number): void {
    this.strength = MathUtils.clamp(strength, 0.1, 5);
  }

  public getStrength(): number {
    return this.strength;
  }

  public apply(simulation: Simulation, worldCoord: Coordinate): void {
    const delta = this.mode === 'raise' ? this.strength : -this.strength;
    simulation.modifySand(worldCoord.x, worldCoord.y, delta, this.brushSize);
  }
}
